import { requestApiUser } from "../functions";

export default {
    create: async (data) => {
        const res = await requestApiUser('/passwords', 'POST', data);
        return res;
    },
    findAll: async () => {
        const res = await requestApiUser('/passwords', 'GET');
        return res;
    },
    findById: async (id) => {
        const res = await requestApiUser(`/passwords/${id}`, 'GET');
        return res;
    },
    update: async (id, data) => {
        const res = await requestApiUser(`/passwords/${id}`, 'PUT', data);
        return res;
    },
    delete: async (id) => {
        const res = await requestApiUser(`/passwords/${id}`, 'DELETE');
        return res;
    },
    setDefaultPassword: async (id) => {
        const res = await requestApiUser(`/passwords/default/${id}`, 'PUT');
        return res;
    },
}